import React from 'react'
import HowEcoTiendaView from '../../containers/HowEcoTienda/HowEcoTienda'

const HowEcoTienda = () => {
  return (
    <HowEcoTiendaView/>
  )
}

export default HowEcoTienda